// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"8101c692","115":"8e85953d","541":"4eb06add","845":"28928481","875":"4ab183d4","989":"4e4b8c85"}[chunkId] + ".chunk.js";
};